import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "background.paper",
  border: "1px solid #e5e7eb",
  borderRadius: "12px",
  boxShadow: 24,
  p: 3,
};

export default function ConfirmDeleteModal({
  open,
  onClose,
  onConfirm,
  message = "Are you sure you want to remove it?",
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" component="h2">
          Confirmation
        </Typography>
        <Typography sx={{ mt: 2 }}>{message}</Typography>
        <Box sx={{ textAlign: "right", mt: 2, display: "flex", gap: 1, justifyContent: "flex-end" }}>
          <Button color="inherit" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={onConfirm}>
            Confirm
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
